import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { UsersComponent } from './users.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BnsightsLibraryModule } from 'bnsights-control-library';
import { userService } from './../shared/Services/userService.service';
import { BlockUIModule } from 'ng-block-ui';
import { SubheaderModule } from '../_layout/components/subheader/subheader.module';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { InlineSVGModule } from 'ng-inline-svg';
import { EmptyDataModule } from '../empty-data/empty-data.module';
import { AuthService, BBSFTranslateService, EnvironmentService, UtilityService } from 'bnsights-utilities-library';
import { DataSecretService } from '../shared/Services/data.service';


const routes: Routes = [
  {
    path: '', component: UsersComponent
  }
]
@NgModule({
  declarations: [UsersComponent],
  imports: [
    BlockUIModule.forRoot(),
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    FormsModule,
    BnsightsLibraryModule,
    SubheaderModule,
    NgbModule,
    MatMenuModule,
    MatCheckboxModule,
    InlineSVGModule,
    EmptyDataModule

  ],

  providers: [
   
    userService,
    DatePipe,
    EnvironmentService,
    DataSecretService,
    UtilityService,
    AuthService,
    BBSFTranslateService,
  ]
})
export class UsersModule {
}
